<template>
  <div class="repo_detail">
    <v-navigation-drawer
      :class="{
        'r-drawer': true,
        'full-width': docId === undefined
      }"
      app
      clipped
      permanent
      floating
    >
      <repo-doc-tree :id="id"></repo-doc-tree>
    </v-navigation-drawer>
    <div v-if="docId">
      <doc-detail :repoId="id" :id="id" />
    </div>
  </div>
</template>

<script>
import RepoDocTree from "@/components/RepoDocTree.vue";
import DocDetail from "@/components/DocDetail.vue";

export default {
  name: "Repo",
  props: {
    id: String,
    docId: String
  },
  components: {
    RepoDocTree,
    DocDetail
  }
};
</script>

<style scoped>
.r-drawer.full-width {
  width: 100% !important;
}
</style>
